import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Box, Button } from "@material-ui/core";
import { gpColors } from "../../constants/colors";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import alen_jacob from "../../Images/alen-jacob.jpg";
import { useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import CircularProgress from "@material-ui/core/CircularProgress";
// import CryptoAES from "crypto-js/aes";
// import CryptoENC from "crypto-js/enc-utf8";
// import { useEffect } from "react";
import { setCookie, getCookie } from "../../Functions";
import { trim } from "lodash";
import api from "../Interceptors/axiosInstance";
import Cookies from "js-cookie";
const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 100,
  },
  loginContainer: {
    height: "100vh",
    overflowX: "hidden",
    backgroundImage: `url(${alen_jacob})`,
    backgroundRepeat: "round",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
    backgroundColor: "rgba(54,64,75,0.5)",

    border: "none",
    borderRadius: "24px",
    padding: "1.5rem 1.5rem",
  },
  inputLabel: {
    color: "#fff",
    fontSize: "14px",
  },
  input: {
    display: "block",
    width: "100%",
    padding: "0.85rem 1rem",
    fontSize: "1rem",
    borderRadius: "0.25rem",
    border: "2px solid #c0c0c0",
    fontFamily: "inherit",
    backgroundColor: "#FFFFFF",
    marginBottom: "25px",
  },
  button: {
    padding: "0.85rem 1rem",
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
  },
  icon: {
    textAlign: "center",
    color: "#87898B",
    transform: "scale(3.4)",
  },
  error: {
    paddingTop: "10px",
    textAlign: "center",
    color: "#FF1400",
  },
}));
const GpAdmin = () => {
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const isLocal = window.location.hostname === "localhost";

 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    setLoader(true);

    const res = await api.post("/authenticate", {
      username: trim(username),
      password: trim(password),
    });

    console.log("login response: ", res);

    setLoader(false);

    // Check if res.data contains 'data' and 'jwt'
    if (res.data?.data?.jwt) {
      sessionStorage.setItem("userName", username);

      const { role, accessId } = res.data.data;

      if (role.trim() === "1") {
        navigate(routes.DASHBOARD);
      } else {
        const accId = accessId?.trim();
        if (accId === "1" || accId === "3") {
          navigate(routes.INWARD_SCAN);
        } else {
          navigate(routes.OUTWARD_SCAN);
        }
      }
    } else {
      // Handle error or message from backend
      const message = res.data?.message || "Something went wrong";
      console.log("Backend message: ", message);
      setError(message);
    }

  } catch (error) {
    setLoader(false);
    console.error(error);
    const message = error.response?.data?.message || error.message || "Something went wrong";
    setError(message);
  }
};


  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     setLoader(true);
  //     const resp = await fetch(
  //       `${process.env.REACT_APP_API_ENDPOINT}/authenticate`,
  //       {
  //         method: "POST",
  //         body: JSON.stringify({
  //           username: username,
  //           password: password,
  //         }),
  //         headers: {
  //           "Access-Control-Allow-Origin": "*",
  //           "Content-Type": "application/json",
  //           Accept: "application/json",
  //           // // "ngrok-skip-browser-warning": "true",
  //         },
  //       }
  //     );

  //     const data = await resp.json();
  //     if (!resp.ok) {
  //       throw new Error(data.message || "Something went wrong");
  //     }

  //     console.log(data);
  //     if (data.data && data.data.hasOwnProperty("jwt")) {
  //       setLoader(false);
  //       const value = {
  //         username: username,
  //         password: password,
  //         loginInfo: data,
  //       };

  //       setCookie("guardPlus_user", JSON.stringify(value), 1);
  //       if (data.data.role.trim() === "1") {
  //         navigate(routes.DASHBOARD);
  //       } else {
  //         const accessId = data.data.accessId?.trim();
  //         if (accessId === "1" || accessId === "3") {
  //           navigate(routes.INWARD_SCAN);
  //         } else {
  //           navigate(routes.OUTWARD_SCAN);
  //         }
  //       }
  //       // navigate(routes.ADD_PRODUCTS);
  //     } else if (data.status === 500) {
  //       setLoader(false);
  //       setError("Not authenticated");
  //     } else {
  //       setLoader(false);
  //       setError("Something went wrong");
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //     console.log(error.message);
  //     setError(error.message);
  //   }
  // };

  return (
    <div className={classes.loginContainer}>
      <Container component={"main"} maxWidth="xs">
        <div component={"div"} className={classes.paper}>
          <form className={classes.form} onSubmit={(e) => handleSubmit(e)}>
            <div className={classes.icon}>
              <AccountCircleIcon fontSize="large" />
            </div>
            <div style={{ paddingTop: 40 }}>
              <Box className={classes.inputLabel}>Username</Box>
              <input
                className={classes.input}
                id="username"
                margin="normal"
                required
                placeholder="Username"
                type="text"
                onChange={(e) => setUsername(e.target.value)}
              />
              <Box className={classes.inputLabel}> Password</Box>
              <input
                className={classes.input}
                id="password"
                margin="normal"
                value={password}
                required
                placeholder="Password"
                type="Password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button type="submit" fullWidth className={classes.button}>
                {loader ? <CircularProgress size={25} /> : "LOGIN"}
              </Button>
            </div>
            {/* <div style={{display:'flex', justifyContent:'flex-end', paddingTop:10}}> */}
              {/* <span style={{color:'red', cursor:'pointer'}} onClick={() => navigate(routes.RESETPASS)}>Forgot password?</span> */}
            {/* </div> */}
            <div className={classes.error}>{error}</div>
          </form>
        </div>
      </Container>
    </div>
  );
};
export default GpAdmin;
